import Navbar from './components/Navbar';
import Hero from './components/Hero';
import LatestAddress from './components/LatestAddress';
import AccessGuide from './components/AccessGuide';
import CategoryShowcase from './components/CategoryShowcase';
import FeaturedSites from './components/FeaturedSites';
import Community from './components/Community';
import Faq from './components/Faq';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main className="w-full">
        <Hero />
        <LatestAddress />
        <AccessGuide />
        <CategoryShowcase />
        <FeaturedSites />
        <Community />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}